module.exports = __webpack_public_path__ + "img/logo.af1e9335.png";